<span *ngIf="touched && dirty && invalid" [attr.id]="errorContainerId">
  <span *ngFor="let message of validationMessages" class="text text__warning text__md">
    {{ message }}
  </span>
</span>
